import { useEffect, useState } from "react";
import { Button, Modal, ModalBody, ModalHeader } from "react-bootstrap";
import UploadResumeModal from "../../../modal/jobs/upload-resume/upload-resume.modal";
import { CircularProgress } from "@mui/material";
import "./import-resume.scss";
import ResumeService from "../../../services/resume.service";
import GPTService from "../../../services/gpt.service";
import { ResultImportResumeModel } from "../../../model/import-resume/result-import-resume.model";
import ResumeParserComponent from "./resume-parser";
import PrefillResumeModal from "../../../modal/resume-builder/prefill-resume.modal";
import { InputResumeBuilderModel } from "../../../model/resume-builder/input-resume-builder.model";
import { useNavigate } from "react-router-dom";
import navigateConfig from "../../../navigate.config";


const ImportResumeComponent = ({ open, handleClose, resumeUUID }: any) => {
    const navigate = useNavigate();
    const [isUploadResume, setIsUploadResume] = useState(false);
    const [key, setKey] = useState("");
    const [result, setResult] = useState<ResultImportResumeModel>();
    const [showPrefillModal, setShowPrefillModal] = useState(false);

    useEffect(() => {
        if(key){
            parsingResume(key);
        }
    },[key])

    const clickUploadResume = () => {
        setIsUploadResume(true);
    }

    const handleCloseUpload = () => {
        setIsUploadResume(false);
    }

    const parsingResume = (resumeKey) => {
        const objectResult = {
            resume_key: resumeKey
        }
        GPTService.resumeParser(objectResult).then((res) => {
            if(res.data){
                setResult(res.data);
                // Show prefill modal after parsing is complete
                setShowPrefillModal(true);
            }
        }).catch((err) => {
            console.error("Error parsing resume:", err);
        })
    }

    const handlePrefill = (prefillData: Partial<InputResumeBuilderModel>) => {
        // If resumeUUID is provided, navigate to builder and prefill
        if (resumeUUID) {
            navigate(`${navigateConfig.resume.builder}${resumeUUID}`, {
                state: { prefillData }
            });
        }
        handleClose();
    }

    return (

        <>
            <div className="import-resume-main">
                <Modal show={open} onHide={handleClose} className="import-resume-main">
                    <ModalHeader closeButton></ModalHeader>
                    <ModalBody>
                        {
                            key && !result &&
                            <div className="import-resume-parsing-control">
                                <div className="import-resume-parsing-main">
                                    <span className="import-resume-parsing-key-text">{key}</span>
                                    <div className="import-resume-parsing-main">
                                        <CircularProgress className="import-resume-parsing-loading"></CircularProgress>
                                        <span className="import-resume-parsing-loading-text">กำลังดึงข้อมูล...</span>
                                    </div>

                                </div>
                            </div>

                        }
                        {
                            !key &&
                            <Button onClick={clickUploadResume}>Upload resume</Button>
                        }
                        {
                            result && !showPrefillModal &&
                            <ResumeParserComponent dataMod={result} ></ResumeParserComponent>
                        }

                    </ModalBody>
                </Modal>
            </div>

            {
                isUploadResume &&
                <UploadResumeModal 
                    open={isUploadResume} 
                    handleClose={handleCloseUpload} 
                    setKey={setKey} 
                    pathName={"one_profile"}
                />
            }

            {
                showPrefillModal && result &&
                <PrefillResumeModal
                    open={showPrefillModal}
                    handleClose={() => {
                        setShowPrefillModal(false);
                        handleClose();
                    }}
                    parsedData={result}
                    onPrefill={handlePrefill}
                />
            }
        </>
    )
}

export default ImportResumeComponent;